'use client';

import SvgConnectionError from '@/icons/iconsComponent/ConnectionError';
import { Button } from '../../button';

export const ConnectionError = () => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className='flex w-full flex-col items-center justify-center md:h-[95svh] gap-y-3 text-center'>
      <p className='text-pics h1'>500</p>
      <SvgConnectionError className='text-pics' />
      <div>
        <p className='text-text body-12-bold'>قطع ارتباط با سرور!</p>
        <p className='text-text body-12-regular'>
          ضمن عرض پوزش بابت خطای پیش آمده، در حال بر طرف کردن مشکل هستیم.
          <br /> لطفا مدتی بعد تلاش کنید.
        </p>
      </div>
      <Button onClick={handleRetry}>تلاش مجدد</Button>
    </div>
  );
};
